<template>
  <div class="container" :style="backgroundStyle" @click.self="handleClick">
    <div class="title-postion">
      <div class="Title">
        {{ title }}
      </div>
      <div class="secondary">
        {{ secondary }}
      </div>
    </div>
    <div class="start-position">
      <div class="go" @click="handleClick">
        Démarrer
      </div>
    </div>
  </div>
  
</template>

<script>
import unstarted from '@/assets/status/noncommenc@3x.png'
import pending from '@/assets/status/encours@3x.png'
import finished from '@/assets/status/finished@3x.png'
import LockIcon from '@/components/layout/svg/LockIcon'


export default {
  name: 'VvDesktopTile',
  components: {
    LockIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    secondary: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: String,
      required: false,
      validator(val) {
        return !val || ['unstarted', 'running', 'finished'].includes(val)
      }
    },
    hasAccess: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    icon() {
      if (this.status === 'finished') return finished

      if (this.status === 'running') return pending

      return unstarted
    },
    backgroundStyle() {
      return this.image ? `background: center / cover no-repeat url(${this.image})` : null
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.title-postion {
  padding-top: 160px;
  display: flex;
  justify-content: center;
}
.start-position {
  margin-top: 155px;
}

.container {
  display: flex;
  width: 100%;
  height: 250px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 10px rgba(216, 216, 216, 0.5);
  border-radius: 10px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin-bottom: 50px;
}
.Title {
  text-align: center;
  font: normal normal bold 50px Helvetica;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-shadow: 0px 3px 6px #000000;
  opacity: 1;
}
.secondary {
  text-align: center;
  font: normal normal 600 18px/19px Friends;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-shadow: 0px 3px 6px #000000;
  opacity: 1;
}
.go {
  display: flex;
  height: 75px;
  padding: 0 75px;
  background: $primary 0% 0% no-repeat padding-box;
  border-radius: 19px;
  opacity: 1;
  font: normal normal normal 45px Helvetica;
  letter-spacing: 0px;
  color: #FFFFFF;
  align-items: center;
}
</style>
